import { EyeIcon, EyeOffIcon } from "lucide-react";
import { useState } from "react";
import { type Control, useController } from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { classNames } from "../../../../utils/classNames";
import "../styles/index.css";

interface Props {
  control: Control;
  name: string;
  placeholder?: string;
  icon?: React.ReactElement;
  label?: string;
}

const PasswordField = ({ control, placeholder, label, icon, name }: Props) => {
  const [isPasswordType, setIsPasswordType] = useState(true);
  const [isFocus, setIsFocus] = useState(false);
  const {
    field: { value = "", onChange, ref },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: "",
  });

  const handleBlur = (e) => {
    const value = e.target.value;
    if (!!!value) {
      setIsFocus(false);
    } else {
      setIsFocus(true);
    }
  };

  return (
    <div className={tw`relative`}>
      <div className={tw`bg-[#EEF5F4] rounded-xl`}>
        <div
          className={tw`w-full my-2 text-left mt-4 flex items-center gap-4 p-4`}
        >
          <div className={tw``}>{icon}</div>
          <div className={tw`flex-1 relative pt-2`}>
            <input
              placeholder={placeholder}
              defaultValue={value}
              ref={ref}
              type={isPasswordType ? "password" : "text"}
              id={name}
              className={classNames(
                `${tw`w-full bg-transparent outline-none focus:ring-0`} auth-login-input`
              )}
              onFocus={() => setIsFocus(true)}
              onChange={(e) => {
                onChange(e.target.value);
                setIsFocus(true);
              }}
              onBlur={handleBlur}
            />
            <label
              htmlFor={name}
              className={classNames(
                isFocus
                  ? tw`-translate-y-[125%] text-normal text-gray-500`
                  : tw`-translate-y-1/2`,
                tw`text-gray-600 cursor-text  absolute top-1/2  left-0 transition-all duration-400 ease-in-out`
              )}
            >
              {label}
            </label>
            <button
              onClick={() => setIsPasswordType(!isPasswordType)}
              className={tw`absolute top-1/2 -translate-y-1/2 right-[10px]`}
              type="button"
            >
              {isPasswordType ? <EyeOffIcon /> : <EyeIcon />}
            </button>
          </div>
        </div>
      </div>
      {error && (
        <p className={tw`absolute bottom-0 ml-14 text-red-500 text-xs`}>
          {error?.message}
        </p>
      )}
    </div>
  );
};

export default PasswordField;
